export default "__VITE_ASSET__433FJJEM__"